/**
* @name APP Sigepur
* @autor pedro.rivera@dbaccess.com
* @description
* # name Services --> chatboxServices
* file for call at services for assistance page
*/
class chatboxServices {

  constructor ($resource, SERVICE_URL_CONSTANT) {
    var getChatUserById = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getChatUserById', {}, {
      get: {
        method: 'GET'
      }
    })

    var getChatContacts = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getChatContacts', {}, {
      get: {
        method: 'GET'
      }
      ,timeout :10000
    })

    var getMessageHistory = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getMessageHistory', {}, {
      get: {
        method: 'GET'
      }
    })

    var getMessageById = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/getMessageById', {}, {
      get: {
        method: 'GET'
      }
    })

    var addUserMessage = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/addUserMessage', {}, {
      post: {
        method: 'POST'
      }
    })

    var updateMessage = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/updateMessage', {}, {
      post: {
        method: 'POST'
      }
    })

    var updateChatStatus = $resource(SERVICE_URL_CONSTANT.rosario + '/chat/updateChatStatus', {}, {
      post: {
        method: 'POST'
      },timeout :10000
    })
    return {
      getChatUserById: getChatUserById,
      getChatContacts: getChatContacts,
      getMessageHistory: getMessageHistory,
      getMessageById: getMessageById,
      addUserMessage: addUserMessage,
      updateMessage: updateMessage,
      updateChatStatus: updateChatStatus
    }
  }
}

chatboxServices.$inject = ['$resource', 'SERVICE_URL_CONSTANT']
export default angular.module('services.chatboxServices', [])
.service('chatboxServices', chatboxServices)
.name



// WEBPACK FOOTER //
// ./src/app/u-faculty/chatbox/chatboxServices.js